export enum Environment {
    dev = 'dev',
    int = 'int',
    test = 'test',
    dogfood = 'dogfood',
    prod = 'prod',
    gcc = 'gcc',
    dod = 'dod',
    gccHigh = 'gcchigh'
}

/* eslint-disable-next-line @typescript-eslint/naming-convention */
export const EnvironmentNameTranslation = {
    gcc: 'fairfax'
};
